import { render, staticRenderFns } from "./DevClassList1.vue?vue&type=template&id=8007875e&scoped=true&"
import script from "./DevClassList1.vue?vue&type=script&lang=js&"
export * from "./DevClassList1.vue?vue&type=script&lang=js&"
import style0 from "./DevClassList1.vue?vue&type=style&index=0&id=8007875e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8007875e",
  null
  
)

export default component.exports